export const DEBUG_INFO_CONSTS = {
  titleLabel: 'Информация для отладки',
  oldAdminUrlTitle: 'Публикация в старой админке',
  urlTitle: 'Публикация на сайте'
}
